import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import React from "react";

interface WeightInfoModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * WeightInfoModal — displays tips for logging weight in manual entry
 */
export const WeightInfoModal: React.FC<WeightInfoModalProps> = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
      style={{
        backdropFilter: "blur(4px)",
        backgroundColor: "rgba(13, 28, 24, 0.85)",
        zIndex: 9999, // Use a high z-index value to ensure it appears above the BottomNavbar
      }}
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-tx-dark">How to log weight?</h3>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="space-y-3 text-tx-default">
          <p>
            When logging weight, enter the combined weight you lift, pull, or push in one rep.
          </p>
          <p>
            For example, lifting a 44-lb barbell with 50-lb plates on each side gives you a Weight of 44 + 50 + 50 = <b>144 lbs</b>.
          </p>
          <p>
            For bodyweight exercises such as push-ups, simply record the weight as 0. In cases like weighted pull-ups, only input the weight of the attached plates.
          </p>
        </div>
        <div className="mt-6 flex justify-center">
          <Button
            variant="outline"
            size="lg"
            className="w-full py-6"
            onClick={onClose}
          >
            Got it
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WeightInfoModal;